var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('h3',[_vm._v(_vm._s(_vm.i18n(_vm.params.title, 'filters.title')))])
}
var staticRenderFns = []

export { render, staticRenderFns }